export const APPOINTMENT_STATUS = {
    SCHEDULED: 'SCHEDULED',
    RESCHEDULED: 'RESCHEDULED',
};

export enum APPOINTMENT_CARD_TYPE {
    VIEW_BOOKING = 'VIEW_BOOKING',
    RESUME_BOOKING = 'RESUME_BOOKING',
    SELECT_SLOT = 'SELECT_SLOT',
    COMPLETE_PAYMENT = 'COMPLETE_PAYMENT',
    CONTACT_US = 'CONTACT_US',
}

export enum USER_ADDRESS_SOURCE {
    MOBILE_APP = 'MOBILE_APP',
}

export enum SEO_URL_TYPE {
    SERVICE_CENTRE = 'service-centre',
    CITY = 'city',
    GARAGE_OR_BRAND = 'garageOrBrand',
}

export enum ServiceTypeEnum {
    PERIODIC_SERVICE = 'periodic_service',
    SPECIFIC_REPAIR = 'specific_repair',
    NOT_SURE_ABOUT_ISSUE = 'not_sure_about_issue',
    CAR_SPA_AND_CLEANING = 'car_spa_and_cleaning',
}

export enum USER_POLICY_TYPE {
    NPH = 'NPH',
    PH = 'PH',
}

export enum USER_TIMELIME_STATUS {
    HOME_PAGE = 'HOME_PAGE',
    APPOINTMENT_CONFIRMATION = 'APPOINTMENT_CONFIRMATION',
    PICKUP_START_TRIP = 'PICKUP_START_TRIP',
    PICKUP_VEHICLE_PICKED = 'PICKUP_VEHICLE_PICKED',
    PICKUP_REACHED_GARAGE = 'PICKUP_REACHED_GARAGE',
    ORDER_TIMELINE = 'ORDER_TIMELINE',
    DROP_SCHEDULED = 'DROP_SCHEDULED',
    DROP_SELF_SCHEDULED = 'DROP_SELF_SCHEDULED',
    DROP_VEHICLE_PICKED = 'DROP_VEHICLE_PICKED',
    DROP_REACHED_CUSTOMER = 'DROP_REACHED_CUSTOMER',
    DROP_SELF_REACHED_CUSTOMER = 'DROP_SELF_REACHED_CUSTOMER',
}

export enum PAGE_TYPE {
    LANDING_PAGE = 'LANDING_PAGE',
    CITY_PAGE = 'CITY_PAGE',
    GARAGE_PAGE = 'GARAGE_PAGE',
    NEAR_ME_PAGE = 'NEAR_ME_PAGE',
    COMING_SOON_PAGE = 'COMING_SOON_PAGE',
    LOCATION_VEHICLE_CHECK = 'LOCATION_VEHICLE_CHECK',
}
